import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { Tr } from "../../../../_metronic/i18n/Tr";

const AppInternetGuard: React.FC = () => {
  const t = Tr();
  const [showModal, setShowModal] = useState(!navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setShowModal(false);
    const handleOffline = () => setShowModal(true);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <Modal
      show={showModal}
      backdrop="static"
      keyboard={false}
      centered
      dialogClassName="no-internet-modal"
      contentClassName="bg-transparent border-0"
    >
      <div
        className="rounded-4 shadow-lg text-center mx-auto position-relative p-4 p-md-5"
        style={{
          width: "90%",             // ✅ takes 90% on mobile
          maxWidth: "600px",        // ✅ capped for desktop
          minHeight: "300px",       // ✅ adjusts height
          backgroundImage: `url(${toAbsoluteUrl("/media/auth/bg9-dark.jpg")})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          border: "1px solid rgba(255,255,255,0.2)",
          color: "#fff",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Dark overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.55)",
            zIndex: 1,
          }}
        />

        {/* Content */}
        <div
          className="d-flex flex-column align-items-center justify-content-center h-100"
          style={{ position: "relative", zIndex: 2,top:"50px" }}
        >
          <svg
            width="72"
            height="72"
            viewBox="0 0 24 24"
            className="mb-3 mb-md-4"
            fill="none"
            stroke="white"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2 8.82A15.91 15.91 0 0 1 12 5c3.5 0 6.72 1.13 9.33 3.05"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
            <path
              d="M4.9 12.05A11.94 11.94 0 0 1 12 9.5c2.46 0 4.74.75 6.63 2.03"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
            <path
              d="M7.78 15.13A7.96 7.96 0 0 1 12 14c1.5 0 2.9.39 4.11 1.07"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
            <path
              d="M9.5 18a2.5 2.5 0 0 0 5 0"
              strokeWidth="1.8"
              strokeLinecap="round"
            />
            <path
              d="M3.5 3.5l17 17"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              opacity="0.9"
            />
          </svg>

          <h3 className="fw-bold mb-2 fs-5 fs-md-3" style={{ color: "white" }}>
            {t("No Internet Connection")}
          </h3>
          <p
            className="px-2 px-md-4"
            style={{ color: "rgba(255,255,255,0.9)", fontSize: "14px" }}
          >
            {t("You appear to be offline. Please check your network and try again.")}
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default AppInternetGuard;